
import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface IFlexStyles {
    flexColumn?: boolean,
    spaceBetween?: boolean,
    justifyCenter?: boolean,
    alignItems?: boolean,
    alignItemsLeft?: boolean,
    flex?: string,
}

interface IColumnProps extends IFlexStyles, React.HTMLAttributes<HTMLDivElement> {
    children?: ReactNode,
    className?: string,
    gap?: string
    onClick?: (e: any) => void
 }

const Column: FunctionComponent<IColumnProps> = ({children, ...props}) => {
    return <Container {...props}>{children}</Container>
}

const Container = styled.div<IColumnProps>`
    display: flex;
    flex-direction: column;
    ${({ gap }) => gap && `gap: ${gap};`}
    ${({ spaceBetween }) => spaceBetween && 'justify-content: space-between;'}
    ${({ justifyCenter }) => justifyCenter && 'justify-content: center;'}
    ${({ alignItems }) => alignItems && 'align-items: center;'}
    ${({ alignItemsLeft }) => alignItemsLeft && 'align-items: left;'}
    ${({ flex }) => flex && `flex: ${flex};`}
`;

export default Column